import type { ScrollAreaProps as MantineScrollAreaProps } from '@mantine/core';
import { ScrollArea as MantineScrollArea } from '@mantine/core';

import type { LockedProps } from '../types';

type ScrollAreaProps = Omit<MantineScrollAreaProps, LockedProps>;

export const ScrollArea = (props: ScrollAreaProps) => {
  return <MantineScrollArea {...props} />;
};
